import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installAuthFetch, captureGoogleRedirect } from "./lib/auth";

// Google login dönüşündeki #gtoken'ı yakala, sonra TÜM /api isteklerine Bearer ekle.
captureGoogleRedirect();
installAuthFetch();

// ── TARAYICI ÇEVİRİSİNE KARŞI ZIRH ──────────────────────────────────────────
// Canlıda /content-opportunities beyaz ekrana düştü: "NotFoundError: insertBefore".
// Sebep Chrome Translate: sayfayı çevirirken DOM metin düğümlerini kendi <font>
// etiketlerine sarıyor; React sonraki render'da kendi koyduğu düğümü bulamayınca
// çöküyor (index.html lang="en" yazdığı için Türkçe uygulamada çeviri öneriliyordu —
// o da düzeltildi). Bu yama bilinen çözümdür: removeChild/insertBefore, düğüm
// taşınmışsa fırlatmak yerine sessizce toparlar. React davranışı değişmez;
// yalnız üçüncü tarafın DOM'u karıştırdığı anlar ölümcül olmaktan çıkar.
if (typeof Node !== "undefined") {
  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child; // çeviri düğümü taşımış — React'i düşürme
    return origRemoveChild.call(this, child) as T;
  };
  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) return origInsertBefore.call(this, node, null) as T; // sona ekle
    return origInsertBefore.call(this, node, ref) as T;
  };
}

// Light tema (":root" tanımları) — dark istenirse documentElement'e "dark" sınıfı eklenir.
createRoot(document.getElementById("root")!).render(<App />);
